<section #heroScene class="benin-hero" [style.background-image]="introBackground ? 'url(' + introBackground + ')' : 'none'">
  <div class="benin-hero__container">
    <div class="benin-hero__text-layer">
      <p>We Are Bringing First-World Development To African Cities.</p>
    </div>
  </div>
</section>
